// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { btr as _btr } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the btr chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 200901
 * Chain Name: Bitlayer
 * Default Block Explorer: https://www.btrscan.com
 * Default RPC URL: https://rpc.bitlayer.org
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { btr } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: btr,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const btr = createCommon({
	..._btr,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
